/**
 * LoanBalanceDemo — Loan/Real Estate use case.
 * Dynamic sliders for income vs debt with DTI ratio.
 */
import React, { useState } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import LoanBalanceSlider from '../../components/useCases/LoanBalanceSlider';

export default function LoanBalanceDemo({ onBack }) {
  const [value, setValue] = useState({ income: 6000, debt: 1800 });

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Adjust income and debt to see how debt-to-income ratio affects loan eligibility.
      </Typography>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <LoanBalanceSlider
          value={value}
          onChange={(e) => setValue(e?.target?.value || e)}
          label="Monthly financial snapshot"
          incomeMax={30000}
          debtMax={15000}
        />
      </Paper>
    </Box>
  );
}
